// extracted by mini-css-extract-plugin
module.exports = {"input-custom-cls":"Input_input-custom-cls__FSA8Q","p-float-label":"Input_p-float-label__2JmWd","log-input":"Input_log-input__aJLuY"};